import { Badge } from '@shared/components/ui/badge'
import { AlertCircle, CheckCircle } from 'lucide-react'

interface ActivationStatusBadgeProps {
  isActive: boolean
}

export function ActivationStatusBadge({ isActive }: ActivationStatusBadgeProps) {
  if (isActive) {
    return (
      <Badge variant="secondary" className="flex items-center gap-1">
        <CheckCircle className="w-3 h-3" />
        Cuenta activada
      </Badge>
    )
  }

  return (
    <Badge variant="destructive" className="flex flex-nowrap items-center gap-1">
      <AlertCircle className="w-3 h-3" />
      Inactiva
    </Badge>
  )
}
